import styled from "styled-components";

const CustomSelect = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  apperance: none;
  font-family: "Open Sans";
  background-color: transparent;
  background: none;
  padding: 1px 6px;
  font-size: 1.2rem;
  font-weight: 300;
  color: #383838;
  border: 1px solid #eee;
  width: auto;
`;

export default CustomSelect;
